import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';
import { DropdownOption } from '@/models/DropdownOption';

export class ProductLookupData {
    platforms: Array<DropdownOptionIntegerId>;
    dataOwners: Array<DropdownOptionIntegerId>;
    dataClassificationDetails: Array<DropdownOptionIntegerId>;
    services: Array<DropdownOptionIntegerId>;
    businessGroupCoverages: Array<DropdownOption>;
    productDeliveryStatuses: Array<DropdownOptionIntegerId>;
    geoCoverageLevels: Array<DropdownOption>;
}
